import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function BaseTiredSetting() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
